import {
  getInquiryStatusBadgeType,
  InquiryStatus,
} from "pages/communication/model/inquiryStatus";
import { SuggestionStatus } from "pages/communication/model/suggestionStatus";
import { getSuggestionStatusBadgeType } from "pages/communication/model/suggestionStatusMapper";
import { decrypt } from "shared/lib/crypto/decrypt";

export const communicationAnswerConfigs = {
  ask: {
    detailPath: "inquiries",
    listPath: "/communication/ask",
    title: "문의 답변하기",
    deleteLabel: "문의 삭제하기",
    progressLabel: "진행 중 변경",
    progressStatus: InquiryStatus.IN_PROGRESS,
    waitingStatus: InquiryStatus.WAITING,
    doneStatus: InquiryStatus.DONE,
    answerConfirmMessage:
      "답변등록은 한번만 가능하며 \n문의 리스트에서 수정가능합니다.",
    editConfirmMessage:
      "이전 답변이 수정된 내용으로 바뀌며 \n이전 내용을 다시 복구할 수 없습니다.",
    deleteConfirmMessage:
      "삭제된 문의는 복구 불가합니다.\n정말 삭제하시겠습니까?",
    progressConfirmMessage:
      "진행 중으로 변경시 메인페이지에 진행 중으로 출력됩니다.",
    warningMessages: [
      "문의에 대한 답변은 한 번만 가능합니다.",
      "답변을 달면 자동으로 ‘답변완료'상태로 변경되오니 ‘진행 중’ 상태를 원하실 경우 진행 중 변경 버튼을 클릭하세요.",
    ],
    getUserText: (data) =>
      data.user ? `${data.user.name} | ${decrypt(data.user.email)}` : "",
    getStatusBadgeType: getInquiryStatusBadgeType,
  },
  suggestion: {
    detailPath: "suggests",
    listPath: "/communication/suggestion",
    title: "건의 답변하기",
    deleteLabel: "건의 삭제하기",
    progressLabel: "진행 중 변경",
    progressStatus: SuggestionStatus.IN_PROGRESS,
    waitingStatus: SuggestionStatus.WAITING,
    doneStatus: SuggestionStatus.DONE,
    answerConfirmMessage:
      "답변등록은 한번만 가능하며 \n건의 리스트에서 수정가능합니다.",
    editConfirmMessage:
      "이전 답변이 수정된 내용으로 바뀌며 \n이전 내용을 다시 복구할 수 없습니다.",
    deleteConfirmMessage:
      "삭제된 건의는 복구 불가합니다.\n정말 삭제하시겠습니까?",
    progressConfirmMessage:
      "진행 중으로 변경시 메인페이지에 진행 중으로 출력됩니다.",
    warningMessages: [
      "건의에 대한 답변은 한 번만 가능합니다.",
      "답변을 달면 자동으로 ‘답변완료'상태로 변경되오니 ‘확인중’ 상태를 원하실 경우 확인중 변경 버튼을 클릭하세요.",
    ],
    getUserText: (data) =>
      data.writerEmail ? `${data.writer} | ${decrypt(data.writerEmail)}` : "",
    getStatusBadgeType: getSuggestionStatusBadgeType,
  },
};
